import type { ThemeOptions } from '@mui/material/styles'

export const typography: ThemeOptions['typography'] = {
  fontFamily: '"Barlow", "Helvetica Neue", Arial, sans-serif',

  h1: {
    fontFamily: '"Barlow Condensed", "Barlow", sans-serif',
    fontSize: '4.4rem',
    fontWeight: 700,
    lineHeight: 1.16,
    textTransform: 'uppercase' as const
  },

  h2: {
    fontFamily: '"Barlow Condensed", "Barlow", sans-serif',
    fontSize: '3.8rem',
    fontWeight: 700,
    lineHeight: 1.16,
    textTransform: 'uppercase' as const
  },

  h3: {
    fontFamily: '"Barlow Condensed", "Barlow", sans-serif',
    fontSize: '2.8rem',
    fontWeight: 700,
    lineHeight: 1.16
  },

  h4: {
    fontFamily: '"Barlow Condensed", "Barlow", sans-serif',
    fontSize: '2.4rem',
    fontWeight: 700,
    lineHeight: 1.3
  },

  h5: {
    fontSize: '1.8rem',
    fontWeight: 600,
    lineHeight: 1.4
  },

  h6: {
    fontSize: '1.6rem',
    fontWeight: 600,
    lineHeight: 1.5
  },

  body1: {
    fontSize: '1.6rem',
    lineHeight: 1.6,
    fontWeight: 400
  },

  body2: {
    fontSize: '1.4rem',
    lineHeight: 1.57,
    fontWeight: 400
  },

  subtitle1: {
    fontSize: '1.6rem',
    fontWeight: 500,
    lineHeight: 1.5
  },

  subtitle2: {
    fontSize: '1.4rem',
    fontWeight: 500,
    lineHeight: 1.57
  },

  caption: {
    fontSize: '1.2rem',
    lineHeight: 1.5,
    fontWeight: 400
  },

  overline: {
    fontSize: '1.1rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase'
  },

  button: {
    fontSize: '1.5rem',
    fontWeight: 600,
    letterSpacing: '0.01em',
    textTransform: 'none'
  }
}
